import { render } from "./Ambients.vue?vue&type=template&id=65f9cd8c&scoped=true"
import script from "./Ambients.vue?vue&type=script&lang=js"
export * from "./Ambients.vue?vue&type=script&lang=js"

import "./Ambients.vue?vue&type=style&index=0&id=65f9cd8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65f9cd8c"]])

export default __exports__